import React, { Component } from 'react';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import TableCheckbox from 'Components/TableCheckbox/TableCheckbox.jsx';
export class AgGridCheckboxHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCheckBoxHeaderUpdated: false,
        }
        this.invokeParentMethod = this.invokeParentMethod.bind(this);
    }

    render() {
        const data = this.props.context.componentParent.props.rowData;
        const selectedRows = this.props.context.componentParent.props.selectedRows;
        const index = this.props.context.componentParent.props.rowData.map(row => { return row.caseStageId; });
        return (
            <span
                key={index}
            >
                <InformationBubble
                    tooltipContent={(data !== undefined && selectedRows !== undefined && data.length === selectedRows.length ? 'Deselect All' : 'Select All')}
                    place={'top'}
                    id={index}
                >
                    <span><TableCheckbox
                        id={index}
                        isSvg
                        onChange={this.invokeParentMethod}
                        isChecked={data.length !== 0 && data.length === selectedRows.length}
                    />
                    </span>
                </InformationBubble>
            </span>
        );
    }
    invokeParentMethod() {
        this.setState({
            isCheckBoxHeaderUpdated: true,
        });
        this.props && this.props.context && this.props.context.componentParent && this.props.context.componentParent.props && this.props.context.componentParent.props.onCheckboxClick && this.props.context.componentParent.props.onCheckboxClick(this.props.context.componentParent.props.rowData.length === this.props.context.componentParent.props.selectedRows.length ? [] : this.props.context.componentParent.props.rowData.map(row => { return row.caseStageId; }));
    };
}
export default AgGridCheckboxHeader;